var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIcon14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.088,
    height: 20.022,
    viewBox: "0 0 21.088 20.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12502",
    "data-name": "Group 12502",
    transform: "translate(-1616.876 -30.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38456",
    "data-name": "Path 38456",
    d: "M1635.92,46.962s-1.622-1.376-1.622-5.254.335-10.746-6.878-10.746-6.877,6.869-6.877,10.746-1.623,5.254-1.623,5.254Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38457",
    "data-name": "Path 38457",
    d: "M1630.365,47.289a2.945,2.945,0,0,1-5.89,0",
    fill: "#f7f9fa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon14);
export default __webpack_public_path__ + "static/media/sidebar-icon-14.074df4e0d46441b4849043f6a5ba7f0d.svg";
export { ForwardRef as ReactComponent };